var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChatLinki = function SvgChatLinki(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    width: "1em",
    height: "1em",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color || 'currentColor',
    d: "m9.147 16.184-1.34-1.338a1.06 1.06 0 0 1-.307-.744 1.04 1.04 0 0 1 .307-.738l2.941-2.936a1.07 1.07 0 0 1 1.484 0l.912.9a.424.424 0 0 1 0 .611.43.43 0 0 1-.605 0l-.914-.916a.214.214 0 0 0-.281 0L8.41 13.955a.24.24 0 0 0-.059.145.2.2 0 0 0 .059.148l1.342 1.338a.24.24 0 0 0 .293 0l1.316-1.314a.416.416 0 0 1 .594.014.406.406 0 0 1 0 .594l-1.312 1.313a1.07 1.07 0 0 1-.746.307 1.06 1.06 0 0 1-.75-.316m2.664-2.666-.9-.895a.417.417 0 0 1 0-.6.41.41 0 0 1 .6 0l.9.9a.2.2 0 0 0 .143.061.26.26 0 0 0 .146-.049l2.895-2.908a.2.2 0 0 0 0-.279L14.259 8.41a.25.25 0 0 0-.148-.059.13.13 0 0 0-.119.076l-1.291 1.275a.426.426 0 0 1-.607 0 .426.426 0 0 1 0-.607l1.277-1.289a1.06 1.06 0 0 1 .74-.309 1.07 1.07 0 0 1 .754.316l1.34 1.342a1.035 1.035 0 0 1-.01 1.471l-2.9 2.889a1.03 1.03 0 0 1-.742.3 1.03 1.03 0 0 1-.742-.297"
  }));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChatLinki);
export default ForwardRef;